import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link
} from "react-router-dom";
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import { observable } from 'mobx';
import { sessionService } from '../../services/SessionService';

interface IndexMobilePaymentProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}
@observer export default class IndexMobilePayment extends React.Component<IndexMobilePaymentProps> {

    @observable private mobilePayments: any;
    @observable private isLoaded = false;

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        http.get('/api/mobile_payments/read').then((response: any) => {
            this.mobilePayments = response.data.response || [];
            this.isLoaded = true;
        }).catch((error) => {
            this.isLoaded = true;
            this.mobilePayments = [];
            if (error.response && error.response.status === 404) {
                toast.error("El endpoint de métodos de pago móvil no está disponible. Por favor, verifica que el backend esté configurado.");
            } else {
                toast.error("Error cargando métodos de pago móvil");
            }
        });
    }

    private deleteMobilePayment = (id: any, index: any): void => {
        swal({
            title: "Confirmar acción",
            text: "¿Estas seguro que quieres borrar este método de pago móvil?",
            icon: "warning",
            dangerMode: true,
        })
            .then(willDelete => {
                if (willDelete) {
                    const deleteObject = JSON.stringify({
                        id
                    });
                    http.post(`/api/mobile_payments/delete`, deleteObject)
                        .then(() => {
                            this.mobilePayments.splice(index, 1);
                            toast.success("Método de pago móvil borrado correctamente");
                        }).catch((error) => {
                            if (error.includes("foreign")) {
                                toast.error("Error al borrar: Hay registros ligados a este método de pago");
                            } else {
                                toast.error("Error borrando método de pago móvil");
                            }
                        })
                }
            });
    }

    render() {
        if (!this.isLoaded) {
            return null;
        }
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header card-header-primary">
                                <h4 className="card-title ">Métodos de Pago Móvil</h4>
                                <p className="card-category">
                                    Métodos de pago disponibles para la aplicación móvil
                                </p>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        {sessionService.canViewSection("Pagos Móvil.add") &&
                                            <Link to={`/pagos-movil/nuevo`}>
                                                <button className="btn btn-info btn-lg  pull-right">
                                                    <i className="material-icons">add</i> Nuevo Método
                                                    <div className="ripple-container"></div>
                                                </button>
                                            </Link>
                                        }
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead className=" text-primary">
                                            <tr>
                                                <th>ID</th>
                                                <th>Método de Pago</th>
                                                <th>Descripción</th>
                                                <th className="text-right">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.mobilePayments && this.mobilePayments.length > 0 ? (
                                                    this.mobilePayments.map((mobilePayment: any, index: any) => {
                                                        return (
                                                            <Fragment key={index}>
                                                                <tr>
                                                                    <td>{mobilePayment.id}</td>
                                                                    <td>{mobilePayment.name}</td>
                                                                    <td>{mobilePayment.description || '-'}</td>
                                                                    <td className="td-actions text-right">
                                                                        {sessionService.canViewSection("Pagos Móvil.view") &&
                                                                            <Link to={`/pagos-movil/ver/${mobilePayment.id}`}>
                                                                                <button style={{ margin: 5 }} type="button" className="btn btn-info">
                                                                                    <i className="material-icons">visibility</i>
                                                                                </button>
                                                                            </Link>
                                                                        }
                                                                        {sessionService.canViewSection("Pagos Móvil.edit") &&
                                                                            <Link to={`/pagos-movil/${mobilePayment.id}`}>
                                                                                <button style={{ margin: 5 }} type="button" className="btn btn-success">
                                                                                    <i className="material-icons">edit</i>
                                                                                </button>
                                                                            </Link>
                                                                        }
                                                                        {sessionService.canViewSection("Pagos Móvil.delete") &&
                                                                            <button onClick={() => this.deleteMobilePayment(mobilePayment.id, index)} style={{ margin: 5 }} type="button" className="btn btn-danger" >
                                                                                <i className="material-icons">delete</i>
                                                                            </button>
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            </Fragment>
                                                        )
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={4} className="text-center">
                                                            No hay métodos de pago móvil registrados
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

